// Filename : views/profile.js
define('views/modules/profile/profile',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/layout',
    'services/user',
    'services/unit-converter',
    'services/events/user-events',
    'services/events/calendar-events',
    'services/i18n',
    'services/api',
    // views
    'views/modules/supervisor/supervisor-icon',
    // Models
    'models/member/profile',
    'collections/member/supervisors',
    'models/calendar/personal-data/personal-data-type',
    // Templates
    'text!templates/modules/profile/profile.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    LayoutState,
    User,
    UnitConverter,
    UserEvents,
    CalendarEvents,
    i18n,
    API,
    // views
    VSupervisorIcon,
    // Models
    MProfile,
    Supervisors,
    MPersonalDataType,
    // Templates
    TProfile
) {

    var VProfile = Backbone.Epoxy.View.extend({
        id: "profile",
        template: TProfile,
        events: {
            'click .menu-mobile-link button': 'toggleMenu',
            "click #more-stats": "onMoreStatsClick",
            "click #add-phone-number": "onEditMemberProfile",
            "click #edit-expiration-date": "onEditMemberProfile",
            "click .start-meeting": "onStartMeetingClick"
        },

        regions: {
            root: ".profile-root",
            moreStats: '#more-stats',
            supervisorIcon: '.supervisor-icon',
            weight: '.weight-value',
            waistline: '.waistline-value',
            height: '.height-value'
        },

        initialize: function(opt) {
            this.options = opt || {};

            _.extend(this, {
                view: {},
                bindingSources: { user: User }
            });

            this.listenTo(this.model, {
                'sync': this.render,
                'change:_isSupervisor': this.onSupervisorChange
            })
                .listenTo(User, 'change:units', this.render)
                .listenTo(Supervisors, 'sync', this.render);
            this.listenTo(CalendarEvents, {
                'item:update': this.onCalendarItemChange,
                'session:update': this.onCalendarItemChange,
                'item:destroy': this.onCalendarItemChange,
                'session:destroy': this.onCalendarItemChange,
                'item:itemMove': this.onCalendarItemChange,
                'toggle:done': this.onCalendarItemChange
            });
        },
        render: function() {
            this.initListener();
            var model = this.model,
                data = Mustache.getContext(
                    _.extend({
                        isSupervisor: Supervisors.get(model),
                        hasPhoneNumber: this.hasPhoneNumber(),
                        phoneNumber: this.getPhoneNumber(),
                        formattedInternationalPhoneNumber: this.getInternationalPhoneNumber(),
                    }, model.toJSON()));

            // Render Template HTML with Mustache
            this.$el.empty().append(Mustache.render(this.template, data));
            this.$el.find('.start-meeting').tooltip();

            this.generateZones()
                .renderSupervisorIcon();

            this.model.readyPromise.then(this.applyBindings.bind(this));
            this.setSelectedMember();

            this.renderProfileStats(this.$el.find('#profile-body').empty());
            this.$el.find('#profile-body .ucol-stats').tooltip({ container: '#profile-stats', placement: 'auto' });
        },

        initListener: function() {
            this.stopListeningTo(UserEvents);
            this.listenTo(UserEvents, {
                "profile:update": this.onProfileUpdate,
            });
        },

        hasPhoneNumber: function() {
            if (!this.model.get("phone")) {
                return false;
            } else {
                return true;
            }
        },


        getPhoneNumber: function() {
            if (!this.model.get("phone")) {
                return 'Add number';
            } else {
                return this.model.get("phone");
            }
        },

        getInternationalPhoneNumber: function() {
            if (!this.model.get("phone")) {
                return '';
            } else {
                var rawNumber = this.model.get("phone").match(/\d/g);
                rawNumber = "+" + rawNumber.join("");
                return rawNumber;
            }
        },


        setSelectedMember: function() {
            User.setSelectedUser(this.model);
        },

        renderSupervisorIcon: function() {
            var view = this.view;
            if (Supervisors.get(this.model)) {
                var supervisorIcon = view.supervisorIcon || (view.supervisorIcon = new VSupervisorIcon());
                this.assign(supervisorIcon, this.zone.$supervisorIcon);
            }
        },

        renderProfileStats: function($element) {
            _.each(this.model.get('_stats'), function(stat) {
                var html = '<div class="ucolfix ucol-stats" data-toggle="tooltip" title="'+ i18n.t(stat.name) +'"><h5>'+ i18n.t(stat.name).substr(0, 14) +'</h5><div class="profile-stats-data">' + this.getStatMarkup(stat) + '</div></div>';
                $element.append(html);
            }, this);
        },

        isUnitConvertible: function(unit) {
            return unit === MPersonalDataType.prototype.lengthUnits || unit === MPersonalDataType.prototype.weightUnits || unit === MPersonalDataType.prototype.distanceUnits;
        },

        getStatMarkup: function(stat) {
            var html = '<span>' + stat.value + '</span> <small>' + stat.unit + '</small>';

            if (this.isUnitConvertible(stat.originalUnit) && stat.value !== "-") {
                html = '<span>' + UnitConverter.convert(parseInt(stat.value), stat.unit, this.getUserUnit(stat.originalUnit)) + '</span> <small>' + i18n.t(this.getUserUnit(stat.originalUnit)) + '</small>';
            }

            return html;
        },

        getUserUnit: function(unit) {
            switch (unit) {
                case MPersonalDataType.prototype.lengthUnits: return User.get('lengthUnit');
                case MPersonalDataType.prototype.weightUnits: return User.get('weightUnit');
                case MPersonalDataType.prototype.distanceUnits: return User.get('distanceUnit');
            }
        },

        toggleMenu: function(e) {
            e.preventDefault();
            LayoutState.toggleMenu();
        },

        onMoreStatsClick: function(e) {
            e.preventDefault();
            var zone = this.zone;
            zone.$root.toggleClass('more-stats-open');
            zone.$moreStats.toggleClass('more-stats-open');
        },

        onProfileUpdate: function(model, opt) {
            if (model.is(this.model.id)) {
                this.model.set(opt.attributes ? model.pick(opt.attributes) : model.attributes);
                this.render();
            }
        },

        onEditMemberProfile: function(e) {
            e.stopPropagation();
            UserEvents.editMemberFromProfile(this.model, e);
        },

        onStartMeetingClick: function() {
            if (! Backbone.history.getFragment().includes('messages')) {
                var url = Mustache.render("#/supervisor/group/{{groupId}}/member/{{userId}}/messages/", {
                    groupId: this.model.getMainGroupId(),
                    userId: this.model.id
                });

                Backbone.history.navigate(url, true);
            }

            UserEvents.createMeetingClick();

        },

        onCalendarItemChange: function(model) {
            setTimeout(_.bind(this.fetchUser, this), 1000);
        },

        fetchUser: function() {
            this.model.fetch({ force: true, success: this.render() });
        },

        onDisable: function() {
            this.stopListeningTo(UserEvents);
        },
    });

    return VProfile;

});

